<template>
  <div
    class="license-categories"
    :class="{ 'license-categories--selectable': selectable }"
  >
    <template v-if="selectable">
      <button
        v-for="category in categories"
        :key="category"
        type="button"
        class="license-category-option"
        :class="{ 'license-category-option--selected': isSelected(category) }"
        :aria-pressed="isSelected(category)"
        @click="toggleCategory(category)"
      >
        {{ category }}
      </button>
    </template>

    <template v-else>
      <span
        v-for="category in normalizedValue"
        :key="category"
        class="license-category-badge"
      >
        {{ category }}
      </span>
      <span v-if="normalizedValue.length === 0" class="license-category-empty">
        —
      </span>
    </template>
  </div>
</template>

<script>
import { DRIVER_LICENSE_CATEGORIES } from "@/constants/driverLicenseCategories";

export default {
  name: "DriverLicenseCategories",
  props: {
    modelValue: {
      type: [Array, String],
      default: () => [],
    },
    selectable: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:modelValue"],
  computed: {
    categories() {
      return DRIVER_LICENSE_CATEGORIES;
    },
    normalizedValue() {
      if (Array.isArray(this.modelValue)) {
        return this.modelValue.map((item) => String(item).trim()).filter(Boolean);
      }

      return String(this.modelValue || "")
        .split(",")
        .map((item) => item.trim())
        .filter(Boolean);
    },
  },
  methods: {
    isSelected(category) {
      return this.normalizedValue.includes(category);
    },
    toggleCategory(category) {
      const nextValue = this.isSelected(category)
        ? this.normalizedValue.filter((item) => item !== category)
        : [...this.normalizedValue, category];

      this.$emit("update:modelValue", nextValue);
    },
  },
};
</script>

<style scoped>
.license-categories {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.license-categories--selectable {
  gap: 10px;
}

.license-category-option {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 42px;
  height: 34px;
  padding: 0 10px;
  border: 1px dashed #cbd5e1;
  border-radius: 4px;
  background: #f8fafc;
  color: #64748b;
  font-family: inherit;
  font-size: 14px;
  font-weight: 600;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s, color 0.15s;
}

.license-category-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 42px;
  height: 34px;
  padding: 0 10px;
  border: 1px solid #d5d5d5;
  border-radius: 4px;
  background: #fff;
  color: var(--color-dark);
  font-size: 14px;
  font-weight: 800;
  line-height: 1;
  white-space: nowrap;
}

.license-category-option--selected {
  border-color: var(--color-green);
  border-style: solid;
  background: #ccf2ed;
  color: var(--color-green);
  font-weight: 800;
}

.license-category-option:hover {
  border-color: var(--color-green-hover);
  color: var(--color-green-hover);
}

.license-category-option:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.12);
  border-color: var(--color-green-hover);
}

.license-category-empty {
  color: #666;
  font-weight: 500;
}
</style>
